import { Button } from '@gerdau/hefesto/Button';
import React from 'react';
import { Container } from './styles';

interface IActionsFooterProps {
  onBackClick?(): void;
  disabledNextStep?: boolean;
  nextStepText: string;
  onNextStepClick(): void;
}

const ActionsFooterFacelift: React.FC<IActionsFooterProps> = ({
  onBackClick,
  nextStepText,
  onNextStepClick,
  disabledNextStep
}) => {
  return (
    <Container>
      {onBackClick && (
        <Button name="back" variant="secondary" onClick={onBackClick}>
          Voltar
        </Button>
      )}

      <Button
        name="next-step"
        variant="primary"
        onClick={onNextStepClick}
        disabled={disabledNextStep}
      >
        {nextStepText}
      </Button>
    </Container>
  );
};

export default ActionsFooterFacelift;
